import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTab from "@shared/components/SnTab";
import SnForm from "@widgets/SnForm";
import SnButton from "@shared/components/SnButton";
import SnNumberBox from "@shared/components/SnNumberBox";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";

interface popupProps {
  selectedData?: any;
  scanedRowCount: number;
  isAutoCarton: boolean;
}

const WP3002_POP_001 = forwardRef(
  (
    { selectedData, scanedRowCount, isAutoCarton }: popupProps,
    ref: React.Ref<any>
  ) => {
    const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
      grid1: React.createRef<SnGridRef>(),
    });

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    const formPanel1Ref = useRef<any>(null);
    const numberBoxSelectRef = useRef<any>(null);

    const [panelControlData, setPanelControlData] = useState<any[]>([]);
    const [panelData, setPanelData] = useState<any>({});
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        if (
          !isAutoCarton &&
          panelData.qt_ct - scanedRowCount <
            getGridCurrent("grid1").getCheckedRows().length
        ) {
          await showDialog(
            "alter",
            "포장단위수량의 잔량보다 더 많이 선택되었습니다."
          );
          return false;
        }
        return true;
      },
      getOkayData: () => {
        return {
          rtnData: [getGridCurrent("grid1").getCheckedRows()],
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_POP_WP3002_POP_001",
            {}
          );
          setPanelControlData(rtn.form.form1 || []);
          setColums({
            grid1: rtn.grid.grid1,
          });

          await onSearch();
        } catch (error: any) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_prd_pop_wp3002_pop_001_01",
          params: selectedData,
        };

        const data: any = await fnGetDataSet(param);

        setPanelData(data[0][0] || {});
        setDataSources({
          grid1: data[1] || [],
        });
      } catch (error: any) {}
    };

    const onSnButtonClick = () => {
      getGridCurrent("grid1").setCheckedAll(false);

      if (isAutoCarton) {
        const selectCount = Number(numberBoxSelectRef.current?.getValue ?? 0);

        if (selectCount > 0) {
          // 입력한 수량만큼 위에서부터 선택
          let checked = 0;

          getGridCurrent("grid1").forEachFilteredNode((node: any) => {
            if (checked >= selectCount) return;
            getGridCurrent("grid1").setCheckedRow(node, true, "noEvent");
            checked++;
          });
        } else {
          getGridCurrent("grid1").forEachFilteredNode((node: any) => {
            getGridCurrent("grid1").setCheckedRow(node, true, "noEvent");
          });
        }
      } else {
        const qtCtRemain = panelData.qt_ct - scanedRowCount;

        let checked = 0;

        getGridCurrent("grid1").forEachFilteredNode((node: any) => {
          if (checked >= qtCtRemain) return;
          getGridCurrent("grid1").setCheckedRow(node, true, "noEvent");
          checked++;
        });
      }
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col space-y-2 overflow-hidden">
        <div className="p-2 min-h-[150px]">
          <SnTab
            titles={["직전공정실적정보"]}
            width={"100%"}
            body={[
              <SnForm
                ref={formPanel1Ref}
                data={panelData}
                controls={panelControlData}
              />,
            ]}
          />
        </div>
        <div className="flex-1 min-h-0 p-2">
          <div className="h-full">
            <SnTab
              titles={["실적정보"]}
              width={"100%"}
              header={
                <div className="flex justify-end items-center gap-2">
                  {isAutoCarton && (
                    <div className="w-[80px]">
                      <SnNumberBox inputRef={numberBoxSelectRef} />
                    </div>
                  )}
                  <SnButton text={"일괄선택"} onClick={onSnButtonClick} />
                </div>
              }
              body={[
                <SnGrid
                  ref={gridRefs.current["grid1"]}
                  columnConfig={grids.grid1.columns}
                  rowData={grids.grid1.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    isEditable: false,
                    ischeckboxSelection: true,
                  }}
                />,
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default WP3002_POP_001;
